'use strict';

(function () {
  'use strict';

  angular.module('msSleep').component('msSleepCalendar', {
    templateUrl: 'sleep/pages/sleep-calendar.html',
    controller: SleepCalendar,
    controllerAs: 'vm',
    bindings: {
      latestEntry: '<',
      onSelectedDayChange: '&'
    }
  });
  SleepCalendar.$inject = ['$log'];

  function SleepCalendar($log) {
    var vm = this;
    vm.maxDate = moment().add(-1, 'day');
    vm.hasCompletedStreak = false;
    vm.daysCompleted = 0;

    vm.onUpdateDay = function (day) {
      $log.debug('Picked a new day in the calendar ' + day);
      if (_.isFunction(vm.onSelectedDayChange)) {
        vm.onSelectedDayChange({ day: day });
      } else {
        $log.debug('unable to navigate to day ' + day);
      }
    };
    vm.onGetEntries = function (daysCompleted, hasCompletedStreak) {
      vm.daysCompleted = daysCompleted;
      vm.hasCompletedStreak = hasCompletedStreak;
    };

    vm.checkLastNight = function (completed) {
      vm.isLastNightCompleted = completed;
    };

    ////////////////
    vm.$onInit = function () {
      $log.debug('SleepCalendar activated');
    };
  }
})();